import { QueryClient } from "@tanstack/react-query";
import { planningTemplateQueryKey } from "Planning/PlanningTemplate";
import { itineraryShowsSidebarQueryKey, itinerarySidebarQueryKey } from "show/ItinerarySidebar/base";
import { listTemplateQueryKey } from "components/ListTemplate";

export const invalidateTrainsCache = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: [listTemplateQueryKey, "train_List"] });
  queryClient.invalidateQueries({ queryKey: [itinerarySidebarQueryKey] });
  queryClient.invalidateQueries({ queryKey: [itineraryShowsSidebarQueryKey] });
  queryClient.invalidateQueries({ queryKey: [planningTemplateQueryKey] });
  queryClient.invalidateQueries({ queryKey: ["linkedTravel"] });
}